define((require) => {
    "use strict";

    const {isBlank} = require("shared/util/StringUtils");

    // regular expression borrowed from http://stackoverflow.com/q/46155/725901
    const REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    /**
     * Contains email utility functions.
     *
     * @class EmailUtil
     * @constructor
     */
    return {

        /**
         * Validates the specified email, returning true if considered valid.
         *
         * @param  {String} email The email to be validated; a falsey value will return false.
         * @return {Boolean} True is specified email is valid, false otherwise.
         */
        validateEmail(email) {
            return !isBlank(email) && REGEX.test(email);
        }
    };
});



// WEBPACK FOOTER //
// ./src/editor/util/EmailUtil.js